import api from 'Application/api/api';

const startProject = (id, cancelToken = null) =>
    api.post(`project-manager/projects/${id}/start`, {}, { cancelToken });

export default startProject;
